import Vue from 'vue';

Vue.component('stock-index', () =>
    import(/* webpackChunkName: 'stock-index' */ './stock-index.vue'),
);
